import { render } from "./EditContactPage.vue?vue&type=template&id=482ba5b7&ts=true"
import script from "./EditContactPage.vue?vue&type=script&lang=ts"
export * from "./EditContactPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__